import React, { useEffect } from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import SEO from "./seo.js";
import SideBar from "../sidebar";
import TopBar from "../topbar";
import { settings } from "../../../actions";

const GlobalLayout = (props) => {
  // const { Content } = Layout
  let sidebar = props.sidebar;
  let topbar = props.topbar;
  const topbarOffset = window.innerWidth < 720 ? "56px" : "58px";
  const fixedViewport = props.fixedViewport === true;
  const { token, cardsStatus, getAllDashboardCardsStatus } = props;

  const environment = process.env.NODE_ENV;
  const production = environment === "production";

  useEffect(() => {
    if (token && cardsStatus === null) {
      getAllDashboardCardsStatus();
    }
  }, [token, cardsStatus, getAllDashboardCardsStatus]);

  if (sidebar === undefined) {
    sidebar = true;
  }
  if (topbar === undefined) {
    topbar = true;
  }

  return (
    <Layout style={fixedViewport ? { height: "100vh", overflow: "hidden" } : undefined}>
      {production && (
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(c,l,a,r,i,t,y){
                          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                      })(window, document, "clarity", "script", "fgefddj508");`,
          }}
        ></script>
      )}
      <SEO title={props.title} description={props.description} />
      {topbar ? <TopBar headerNotFixed={props.headerNotFixed} /> : ""}
      <Layout
        style={
          fixedViewport
            ? { height: `calc(100vh - ${topbarOffset})`, overflow: "hidden" }
            : undefined
        }
      >
        <div className="show-on-web">
        {sidebar ? <SideBar /> : ""}
        </div>
        {topbar && !props.headerNotFixed ? (
          <div
            style={{
              display: `${
                props.display === "flex" || props.display === undefined
                  ? "flex"
                  : props.display
              }`,
              width: "auto",
              maxWidth: "100%",
              flex: 1,
              minWidth: 0,
              marginTop: topbarOffset,
              ...(fixedViewport
                ? {
                    height: `calc(100vh - ${topbarOffset})`,
                    minHeight: 0,
                    overflow: "hidden",
                  }
                : { minHeight: `${props.minHeight ? props.minHeight : "100vh"}` }),
              
            }}
          >
            {props.children}
          </div>
        ) : (
          <div
            style={{
              display: `${
                props.display === "flex" || props.display === undefined
                  ? "flex"
                  : props.display
              }`,
              width: "auto",
              maxWidth: "100%",
              flex: 1,
              minWidth: 0,
              margin: 0,
              minHeight: `${props.minHeight ? props.minHeight : "100vh"}`,
              maxHeight: `${props.maxHeight ? props.maxHeight : ""}`,
            }}
          >
            {props.children}
           
          </div>
        )}
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
  cardsStatus: state.settings.cardsStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getAllDashboardCardsStatus: () =>
    dispatch(settings.getAllDashboardCardsStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLayout);
